
<div *ngIf="this.user">
<button *ngIf="!openedMeeting && (this.user.roles.editor || this.user.roles.admin)"
  class="btn btn-small meeting-button video-chat"
  type="button"
  mat-button
  (click)="openDialog()"
>
<img width="40" src="../assets/img/meeting.png">
</button>
</div>
<router-outlet></router-outlet>
